import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { ReactComponent as AttachmentsSVG } from '../../assets/icons/attachments.svg';
import { ReactComponent as DoubleTickSVG } from '../../assets/icons/doubleTick.svg';
import { ReactComponent as EmojiSVG } from '../../assets/icons/emoji.svg';
import { ReactComponent as GoBackSVG } from '../../assets/icons/goBack.svg';
import { ReactComponent as SendSVG } from '../../assets/icons/send-return.svg';
import {
  Avatar,
  Button,
  Divider,
  TextArea,
  Typography,
} from '../../designComponents';
import { fake_avatar_url } from '../../utils';
import { VisibleScreenType } from '.';
import {
  ActiveMessagingContainer,
  AvatarOnlineWrapper,
  ConversationContainer,
  IndividualMessage,
  MessageInputContainer,
} from './style';

const messages = [
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: true,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: true,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: true,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: true,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: true,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: true,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
  {
    myMessages: false,
    message:
      'You have approved the proposal for the hotel escape plan and a contract has been sent .',
    sentDate: new Date(),
    avatar: fake_avatar_url,
  },
];

type Props = {
  changeVisibleScreen?: (value: VisibleScreenType) => void;
};

const ActiveMessage = ({ changeVisibleScreen }: Props) => {
  const isMobileView = useMediaQuery({ query: '(max-width:700px)' });
  const [newMessage, setNewMessage] = useState('');

  const handleNewMessageChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const { value } = e.target;
    setNewMessage(value);
  };
  return (
    <ActiveMessagingContainer>
      <div className="chat-header-container">
        {isMobileView && (
          <GoBackSVG
            width={20}
            onClick={() =>
              changeVisibleScreen && changeVisibleScreen('chatList')
            }
          />
        )}
        <AvatarOnlineWrapper $isOnline>
          <Avatar size="md" src={fake_avatar_url} alt="" />
        </AvatarOnlineWrapper>
        <div>
          <Typography fontColor="dark">Binod Chaulagain</Typography>
          <Typography variant="caption">Active Now</Typography>
        </div>
      </div>
      <ConversationContainer>
        {messages &&
          messages.map((msg: any, index: number) => (
            <div key={index}>
              <IndividualMessage $isMyMessage={msg.myMessages}>
                <Avatar size="md" src={msg.avatar} />
                <div className="message-wrapper">
                  <Typography className="message">{msg?.message}</Typography>
                  <Typography className="time">
                    12:00 PM <DoubleTickSVG className="double-tick" />
                  </Typography>
                </div>
              </IndividualMessage>
              {index % 3 === 0 && <Divider text="Yesterday" spaceY="32px" />}
            </div>
          ))}
      </ConversationContainer>
      <MessageInputContainer>
        <Divider spaceY="10px" />
        <div className="input-wrapper">
          <TextArea
            className="message-input"
            onChange={handleNewMessageChange}
            value={newMessage}
            maxRow={2}
            placeholder="Type a Message..."
            styleTextArea={{ padding: '7px 20px', borderColor: 'transparent' }}
          />
          <EmojiSVG className="icon-btn emoji " />
          <AttachmentsSVG className="icon-btn attachment" />
          <Button variant="secondary" size="sm">
            Send <SendSVG />
          </Button>
        </div>
      </MessageInputContainer>
    </ActiveMessagingContainer>
  );
};

export default ActiveMessage;
